import React, { useState } from 'react';
import { PaperAirplaneIcon } from './Icons';
import { useFlight } from '../contexts/FlightContext';

const NewsInputField: React.FC = () => {
  const { addNewsMessage } = useFlight();
  const [message, setMessage] = useState('');

  const handleSend = () => {
    if (message.trim()) {
      addNewsMessage(message);
      setMessage('');
    }
  };
  
  const handleKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') {
          handleSend();
      }
  }

  return (
    <div className="bg-slate-900/60 backdrop-blur-md border border-slate-700 rounded-xl shadow-lg p-4">
      <h3 className="text-lg font-bold text-blue-400 mb-3">Add Announcement / Comment</h3>
      <div className="flex items-center gap-2">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type your message here..."
          className="flex-grow py-2 px-3"
        />
        <button
          onClick={handleSend}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg flex items-center gap-2 transition-colors duration-200"
        >
          <PaperAirplaneIcon className="w-5 h-5 -rotate-45" />
          Send
        </button>
      </div>
    </div>
  );
};

export default NewsInputField;